import * as marietta from '../..';
import { ITEM_MODE_KEY, ITEM_MODE_NAME_ENG, ITEM_MODE_NO } from '../Constants';
import { FloorLayer } from './index';

export default class FloorShitaeLayer extends FloorLayer {
    floor: number;

    // eslint-disable-next-line camelcase
    layer_shitae: marietta.webcad.layer.ShitaeLayer;

    // viewObj;
    x: number;

    y: number;

    allLayers: marietta.webcad.layer.ItemLayer[];

    /**
     * 初期設定(override)
     */
    init() {
      this.viewObj.setAttribute('id', `floorShitae${this.floor}`);

      // create each ItemLayer in Order
      this.layer_shitae = new marietta.webcad.layer.ShitaeLayer(ITEM_MODE_NO.MODE_SHITAE_NO, ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG, ITEM_MODE_KEY.MODE_SHITAE_KEY, this.spt, this);

      // 全レイヤーの登録
      this.allLayers = [this.layer_shitae];
    }
}
